import { Component, ElementRef, Input, OnInit, inject } from '@angular/core';

@Component({
  selector: 'bepatient-dynamic-menu-secondary-button-container',
  templateUrl: './secondary-button-container.component.html',
  styleUrls: ['./secondary-button-container.component.scss'],
  standalone: false
})
export class SecondaryButtonContainerComponent implements OnInit {
  private elementRef = inject(ElementRef);

  @Input() title: string;
  @Input() color: string;

  ngOnInit() {
    this.elementRef.nativeElement.style.setProperty(
      '--data-menu-color',
      this.color
    );
  }
}
